export default __webpack_public_path__ + "static/media/cross.f12cacea.svg";